import { textStyles as t } from "../../textStyles.es.js";
import { defineStyle as e, defineStyleConfig as o } from "@chakra-ui/react";
import { TableAnatomy as r } from "./Table.anatomy.es.js";
const a = e({
  borderLeftWidth: "1px",
  borderStyle: "solid"
}), i = e({
  borderRightWidth: "1px",
  borderStyle: "solid"
}), l = e({
  align: "center",
  textAlign: "center"
}), d = e({
  align: "left",
  textAlign: "left"
}), n = e({
  align: "right",
  textAlign: "right"
}), s = e({
  background: "var(--chakra-colors-neutral-50)"
}), g = {
  parts: r.keys,
  baseStyle: {
    actions: {},
    avatar: {
      display: "flex",
      alignItems: "center",
      gap: "spacing-100"
    },
    avatarBadge: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
      width: "fit-content"
    },
    avatarContent: {
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flex: 1,
      gap: "spacing-75"
    },
    avatarEmpty: {
      ...t.lg,
      fontWeight: 500
    },
    avatarSubTitle: {
      ...t.sm,
      color: "primary.700",
      fontWeight: 400,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    avatarTitle: {
      ...t.lg,
      color: "primary.700",
      fontWeight: 500,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    container: {
      overflowY: "hidden",
      overflowX: "auto",
      width: "full"
    },
    table: {
      width: "full",
      borderRadius: "radius-150",
      ...t.md,
      tbody: {
        backgroundColor: "#fff"
      },
      thead: {
        height: "size-500",
        backgroundColor: "neutral.100",
        borderBottom: "1px solid",
        borderColor: "primary.100",
        borderTopLeftRadius: "radius-150",
        borderTopRightRadius: "radius-150"
      },
      "*": {
        borderColor: "primary.100"
      },
      "&[data-animation='true']": {
        animation: "fade-out 1.5s ease-out forwards",
        "@keyframes fade-out": {
          "0%": {
            opacity: 0
          },
          "100%": {
            opacity: 1
          }
        }
      }
    },
    theadRow: {
      backgroundColor: "neutral.100",
      borderRadius: "radius-150"
    },
    theadHeader: {
      ...t.sm,
      fontWeight: "medium",
      height: "size-500",
      paddingY: "spacing-125",
      paddingX: "spacing-150",
      cursor: "default",
      backgroundColor: "neutral.100",
      "& > *:not(:empty)": {
        paddingY: "spacing-25"
      },
      color: "primary.700",
      textAlign: "left",
      textTransform: "uppercase",
      '&[data-hover-enabled="true"]': {
        "&:hover, &._hover": {
          cursor: "pointer",
          backgroundColor: "neutral.200"
        }
      },
      _first: {
        position: "sticky",
        left: 0,
        zIndex: 3
      }
    },
    tbodyRow: {
      position: "relative",
      width: "full",
      "&:hover, &._hover": {
        td: {
          backgroundColor: "neutral.50"
        }
      },
      "&:active, &._active": {
        td: {
          backgroundColor: "primary.50",
          boxShadow: "inset 0px -1px 0px 0px var(--chakra-colors-primary-200)"
        }
      },
      '&[data-hover-enabled="true"]': {
        cursor: "pointer",
        '&[data-checked="true"]': {
          td: {
            backgroundColor: "secondary.25",
            boxShadow: "inset 0px -1px 0px 0px var(--chakra-colors-secondary-500)"
          },
          "&:hover, &._hover": {
            td: {
              backgroundColor: "secondary.50"
            }
          },
          "&:active, &._active": {
            td: {
              backgroundColor: "secondary.100",
              boxShadow: "inset 0px -1px 0px 0px var(--chakra-colors-secondary-600)"
            }
          }
        }
      },
      _last: {
        borderWidth: "0px",
        "& > td": {
          borderWidth: 0
        }
      }
    },
    tbodyData: {
      paddingY: "spacing-125",
      paddingX: "spacing-150",
      verticalAlign: "middle",
      color: "primary.400",
      fontWeight: 400,
      backgroundColor: "white",
      maxWidth: "200px",
      minWidth: "200px",
      boxShadow: "inset 0px -1px 0px 0px var(--chakra-colors-primary-100)",
      '&[data-first="true"]': {
        position: "sticky",
        left: 0,
        top: 0,
        color: "primary.600",
        fontWeight: 500,
        zIndex: 10
      }
    },
    tcellAlignCenter: l,
    tcellAlignLeft: d,
    tcellAlignRight: n,
    tcellBackground: s,
    tcellBorderLeft: a,
    tcellBorderRight: i,
    shadow: {
      zIndex: 1,
      height: "100%",
      position: "absolute",
      right: 0,
      top: 0,
      width: "100%",
      boxShadow: "0px 0px 13px 5px rgba(0, 0, 0, 0.03)",
      clipPath: "inset(0px -18px 0px 0px)",
      pointerEvents: "none"
    },
    shadowContent: {
      position: "relative",
      zIndex: 2
    },
    shortcuts: {
      opacity: 0,
      transition: "opacity 300ms cubic-bezier(0.000, 0.000, 0.580, 1.000)",
      _groupHover: {
        opacity: 1
      }
    },
    skeletonTbodyRow: {
      height: "size-800",
      "&:hover, &._hover": {
        backgroundColor: "unset"
      },
      "&:active, &._active": {
        backgroundColor: "unset"
      }
    },
    skeletonTd: {
      paddingX: "spacing-100",
      minWidth: "120px",
      width: "120px",
      maxWidth: "100%"
    },
    skeletonFullTd: {
      paddingX: "spacing-100",
      maxWidth: "100%"
    },
    skeletonCell: {
      height: "size-200",
      backgroundColor: "primary.100",
      borderRadius: "radius-50",
      animation: "pulse 1.8s cubic-bezier(1,0,.6,-1) infinite",
      animationFillMode: "both",
      "@keyframes pulse": {
        "50%": { opacity: "50%" }
      }
    }
  }
}, u = o({
  baseStyle: {
    overflow: "hidden",
    borderRadius: "radius-50",
    img: {
      objectFit: "cover",
      width: "full",
      height: "full"
    }
  },
  sizes: {},
  variants: {
    landscape: {
      width: "113px",
      height: "64px"
    },
    portrait: {
      width: "37px",
      height: "64px"
    },
    square: {
      width: "64px",
      height: "64px"
    }
  }
});
export {
  g as Table,
  u as TableImage
};
//# sourceMappingURL=Table.es.js.map
